import { render, staticRenderFns } from "./Fusai.vue?vue&type=template&id=3ef86090&scoped=true&"
import script from "./Fusai.vue?vue&type=script&lang=js&"
export * from "./Fusai.vue?vue&type=script&lang=js&"
import style0 from "./Fusai.vue?vue&type=style&index=0&id=3ef86090&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef86090",
  null
  
)

export default component.exports